import React from 'react';
import { TextField, Label } from '@fluentui/react';
import { IUserInfo } from '../../models/IFormData';
import { useTranslation } from 'react-i18next';

import styles from './Reporter.module.scss';

export interface IReporterProps {
	userinfo: IUserInfo;
	error?: string;
	onChange: (user: IUserInfo) => void;
}

export const Reporter = (props: IReporterProps) => {
	const { t } = useTranslation();

	return (
		<div className={styles.reporter}>
			<Label required>{t('reporter.label')}</Label>
			<div className={styles.content}>
				<div className={styles.twoColumn}>
					<ReporterField label={t('reporter.name')} value={`${props.userinfo.firstname} ${props.userinfo.lastname}`} />
					<ReporterField label={t('reporter.email')} value={props.userinfo.email} />
				</div>
				<div className={styles.twoColumn}>
					<TextField
						label={t('reporter.phone')}
						value={props.userinfo.phone}
						onChange={(ev, value) => props.onChange({ ...props.userinfo, phone: value! })}
					/>
					<ReporterField label={t('reporter.department')} value={props.userinfo.department} />
				</div>
			</div>
			{props.error !== '' ? <div className={styles.errorText}>{props.error}</div> : <></>}
		</div>
	);
};

interface IFieldProps {
	label: string;
	value: string;
}

const ReporterField = (props: IFieldProps) => {
	return <TextField label={props.label} disabled readOnly value={props.value} />;
};
